import { useEffect, useState } from 'react';
import { css, cx } from '@eti/styles';
import { m as motion } from 'framer-motion';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const devBarStyles = css`
  backdrop-filter: blur(2px);
  background-color: rgb(240 240 240 / 80%);
  border-top: 1px solid rgb(236 236 236 / 80%);
  display: flex;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica', 'Arial', sans-serif;
  -webkit-font-smoothing: subpixel-antialiased;
  overflow-x: auto;
  padding: 1rem 0 40px;
  text-align: center;

  html[dir='rtl'] & {
    flex-direction: row-reverse;
  }

  & > *:not(:last-child) {
    margin-right: 20px;
  }
`;
const toggleButtonClass = css`
  background: rgb(240 240 240 / 80%);
  border: 1px solid rgb(236 236 236 / 80%);
  border-bottom: 0;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  cursor: pointer;
  padding: 10px 10px 4px;
  position: absolute;
  right: 8px;
  top: -33px;

  &:focus {
    outline: none;
  }

  & svg {
    fill: #307be8;
    height: 16px;
    pointer-events: none;
    width: 16px;
  }
`;
const motionVariants = {
  hidden: {
    y: 0
  },
  visible: {
    y: '-69px'
  }
};
const animatedBarWrapperStyles = css`
  left: 0;
  position: fixed;
  right: 0;
  top: 100%;
  z-index: 30;
`;
const DevBar = ({
  children,
  className
}) => {
  const [showDevBar, setShowDevBar] = useState(() => {
    const savedState = localStorage.getItem('eti.dev.showDevBar');
    return savedState !== null ? JSON.parse(savedState) : false;
  });
  useEffect(() => {
    const handleKeyPress = event => {
      if (event.key === '§') {
        setShowDevBar(s => !s);
      }
    };
    document.addEventListener('keydown', handleKeyPress, false);
    return () => {
      document.removeEventListener('keydown', handleKeyPress, false);
    };
  }, []);
  useEffect(() => {
    localStorage.setItem('eti.dev.showDevBar', JSON.stringify(showDevBar));
  }, [showDevBar]);
  return /*#__PURE__*/_jsxs(motion.section, {
    animate: showDevBar ? 'visible' : 'hidden',
    "aria-label": "Debug tools",
    className: cx(animatedBarWrapperStyles, className),
    "data-testid": "devBar",
    initial: "hidden",
    transition: {
      stiffness: 250,
      damping: 18
    },
    variants: motionVariants,
    children: [/*#__PURE__*/_jsx("div", {
      className: devBarStyles,
      children: children
    }), /*#__PURE__*/_jsx("button", {
      className: toggleButtonClass,
      "data-testid": "toggleDevBar",
      onClick: () => setShowDevBar(!showDevBar),
      title: "Toggle Dev Bar",
      type: "button",
      children: /*#__PURE__*/_jsxs("svg", {
        viewBox: "0 0 64 64",
        xmlns: "http://www.w3.org/2000/svg",
        children: [/*#__PURE__*/_jsx("path", {
          d: "M37.7 45.956l10.089 10.089 5.36 7.185L56 64l7.9-7.955-.766-2.91L56 47.826 45.364 37.185l-7.532 7.532a7.688 7.688 0 0 1-.132 1.239zm17.536 5.917a3.347 3.347 0 1 1-3.347 3.347 3.347 3.347 0 0 1 3.345-3.347zM33.368 25.188l-5.911-5.911a9.806 9.806 0 0 0 1.215-4.359c0-7.587-7.255-14.928-14.839-14.839-.029 0-.887.87-1.353 1.337 6.078 6.079 5.576 5.091 5.576 8.819 0 3.025-4.846 7.8-7.8 7.8-3.828 0-2.608.634-8.818-5.577C.952 12.942.1 13.786.1 13.815c.092 7.586 7.255 14.84 14.84 14.84a9.763 9.763 0 0 0 4.292-1.168l5.368 5.372a7.742 7.742 0 0 1 1.233-.137z"
        }), /*#__PURE__*/_jsx("path", {
          d: "M57.554 38.12l4.046 3.938s5.827-16.152-1.092-23.071c-2.5-2.5-6.2-6.195-9.1-9.1-.629-.628-2.391-.061-2.845-.664a11.345 11.345 0 0 1-1.843-3.487c-.277-1.336-1.693-2.636-2.837-3.78l-.427-.426C42.5.577 42.01 0 41.43 0c-.484 0-1.03.4-1.954 1.328l-5.538 5.538c-2.031 2.031-1.549 2.232.2 3.98l.427.427c1.275 1.275 2.744 2.888 4.232 2.888h.054c1.145.214 3.511.884 4.6 2.883 1.2 2.647-.494 4.467-1.172 5.483L27.432 37.372a4.687 4.687 0 0 0-1.4-.233 2.942 2.942 0 0 0-2.153.861l-.473.473S11.179 50.7 8.006 53.875l-.473.475c-3.018 3.018 2.492 9.538 6.512 9.538a2.95 2.95 0 0 0 2.158-.869l.475-.472c3.18-3.182 15.4-15.4 15.4-15.4l.473-.473a3.353 3.353 0 0 0 .631-3.556l16.637-16.639c1.037-.868 2.069-1.669 2.658-1.669a.452.452 0 0 1 .233.057c6.021 3.456 4.844 13.253 4.844 13.253z"
        })]
      })
    })]
  });
};
export default DevBar;
//# sourceMappingURL=DevBar.js.map